import { breakpoints } from "@brightagency/headstart-common";
import { createGlobalStyle } from "styled-components";
import { zIndex } from "../../constants";
import { colors } from "../../utils/colors";

export const RegionGlobalStyles = createGlobalStyle`

	html {
		background-color: ${colors.brandMid};

		${breakpoints.medium} {
			background-color: ${colors.brandDark};
		}
	}

	#nprogress {
		pointer-events: none;
	}

	#nprogress .bar {
		background: ${colors.brandLight};
		z-index: ${zIndex.nProgress};
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 4px;
	}

	#nprogress .peg {
		display: block;
		position: absolute;
		right: 0px;
		width: 100px;
		height: 100%;
		opacity: 1;
		transform: rotate(3deg) translate(0px, -4px);
	}

	#nprogress .spinner {
		display: block;
		position: fixed;
		z-index: 1031;
		top: 15px;
		right: 15px;
	}

	.nprogress-custom-parent {
		overflow: hidden;
		position: relative;
	}

	.nprogress-custom-parent #nprogress .spinner,
	.nprogress-custom-parent #nprogress .bar {
		position: absolute;
	}
`;
